import { render, staticRenderFns } from "./nickname.vue?vue&type=template&id=d5c4b69e&scoped=true"
import script from "./nickname.vue?vue&type=script&lang=js"
export * from "./nickname.vue?vue&type=script&lang=js"
import style0 from "./nickname.vue?vue&type=style&index=0&id=d5c4b69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c4b69e",
  null
  
)

export default component.exports